import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import { MESSAGE_LIST_CONTAINER } from './messageListContainer';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  containerType: 'inline-size',
  containerName: MESSAGE_LIST_CONTAINER,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * Vertical list of `MessageListItem` rows separated by hairline dividers.
 * Rows switch from a stacked mobile layout to a single scannable line once the list is wide enough,
 * based on the list's own width (container query), not the viewport.
 */
export function MessageList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'message-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as MessageListProps };
